import Icons from "./icons";


const SideMenuIcons = {

    "defaultIcon" :  <Icons.ProductsV2 height={19} width={19} />,

    "dashboard-icon.svg" : <Icons.DashboardMenuV2 height={19} width={19} />,
    "products-icon.svg" : <Icons.ProductsV2 height={19} width={19} />,
    "sales-indent-icon.svg" : <Icons.SalesIndentV2 height={19} width={19} />,
    "purchase-orders-icon.svg" : <Icons.PurchaseOrdersV2 height={19} width={19} />,
    "shipments-icon.svg" : <Icons.ShipmentsV2 height={19} width={19} />,
    "logistics-icon.svg" : <Icons.LogisticsV2 height={19} width={19} />,
    "grc-icon.svg" : <Icons.GrcV2 height={19} width={19} />,
    "ledger-icon.svg" : <Icons.LedgerV2 height={19} width={19} />,
    "report-and-analytics-icon.svg" : <Icons.ReportsAndAnalyticsV2 height={19} width={19}/>, 
    "administration-icon.svg" : <Icons.AdministrationV2 height={19} width={19}/>, 
    "master-data-icon.svg" : <Icons.MasterDataV2 height={19} width={19}/>, 

    "mappings-icon.svg" : <Icons.MappingsV2 height={19} width={19} />,
    "assortment-icon.svg" : <Icons.AssortmentV2 height={19} width={19} />,
    "run-replenishment-icon.svg" : <Icons.RunReplenishmentV2 height={19} width={19} />,
    "planning-orders-icon.svg" : <Icons.PlanningOrdersV2 height={19} width={19} />,
    "adhoc-requests-icon.svg" : <Icons.AdhocRequestsV2 height={19} width={19} />,
    "history-icon.svg" : <Icons.HistoryV2 height={19} width={19} />,
    
    "quality-check-icon.svg" : <Icons.QualityCheckV2 height={19} width={19} />,
    "asn-icon.svg" : <Icons.AsnV2 height={19} width={19} />,
    "finance-icon.svg" : <Icons.FinanceV2 height={19} width={19} />,
    "manage-icon.svg" : <Icons.ManageV2 height={19} width={19} />,

    "lr-processing-icon.svg" : <Icons.LrProcessingV2 height={19} width={19} />,
    "grc-status-icon.svg" : <Icons.GrcStatusV2 height={19} width={19} />,
    "sale-orders-icon.svg" : <Icons.SaleOrdersV2 height={19} width={19} />,
    "delivery-challan-icon.svg" : <Icons.DeliveryChallanV2 height={19} width={19} />,
    "pricelist-icon.svg" : <Icons.PricelistV2 height={19} width={19} />,

    "agents-icon.svg" : <Icons.AgentsV2 height={17} width={17} />,
    "sets-icon.svg" : <Icons.SitesV2 height={19} width={19} />,
    "vendors-icon.svg" : <Icons.VendorsV2 height={16} width={16} />,
    "mailing-list-icon.svg" : <Icons.MailingListV2 height={17} width={17} />,
    "costsheet-library-icon.svg" : <Icons.CostSheetLibraryV2 height={17} width={17} />,
    "items-icon.svg" : <Icons.ItemsV2 height={17} width={17} />,
    "transports-icon.svg" : <Icons.TransportersV2 height={17} width={17} />,
    "fabric-library-icon.svg" : <Icons.FabricLibraryV2 height={17} width={17} />,
    "material-library-icon.svg" : <Icons.MaterialLibraryV2 height={17} width={17} />,
    "customers-icon.svg" : <Icons.CustomersV2 height={17} width={17} />,
    "sales-agents-icon.svg" : <Icons.SalesAgentsV2 height={19} width={19} />,
    "sites-icon.svg" : <Icons.SitesV2 height={17} width={17} />,

    "manage-roles-icon.svg" : <Icons.ManageRolesV2 height={19} width={19} />,
    "create-roles-icon.svg" : <Icons.CreateRolesV2 height={19} width={19} />,
    "global-configuration-icon.svg" : <Icons.GlobalConfigurationV2 height={17} width={17} />,
    "user-data-mapping-icon.svg" : <Icons.UserDataMappingV2 height={17} width={17} />,
    "users-icon.svg" : <Icons.UsersV2 height={17} width={17} />,
    "data-sync-icon.svg" : <Icons.DataSyncV2 height={19} width={19} />,
    "audit-logs-icon.svg" : <Icons.AuditLogsV2 height={19} width={19} />,
    "api-logs-icon.svg" : <Icons.ApiLogsV2 height={17} width={17} />,
    "system-mails-icon.svg" : <Icons.SystemMailsV2 height={17} width={17} />,
    "roles-icon.svg" : <Icons.RolesV2 height={17} width={17} />,

    "replenishments-icon.svg" : <Icons.ReplenishmentV2 height={15} width={15} />,
    "inventory-controls-icon.svg" : <Icons.InventoryControlV2 height={15} width={15} />,
    // "sales-kpi-icon.svg" : <Icons.InventoryControlV2 height={15} width={15} />,
    "admin-icon.svg" : <Icons.AdminV2 height={15} width={15} />,
    "sales-icon.svg" : <Icons.SalesV2 height={17} width={17} />,
    "purchase-icon.svg" : <Icons.PurchaseV2 height={17} width={17} />,
    "accounting-icon.svg" : <Icons.AccountingV2 height={15} width={15} />,
    "stock-icon.svg" : <Icons.StockV2 height={15} width={15} />,
    "report-and-analytics-logistics-icon.svg" : <Icons.ReportAnalyticsLogisticsV2 height={15} width={15} />,
    "report-and-analytics-shipment-icon.svg" : <Icons.ReportAnalyticsShipmentV2 height={15} width={15} />,

    "set-icon.svg" : <Icons.SetV2 height={15} width={15} />,
    "replenishment-summary-icon.svg" : <Icons.ReplenishmentSummaryV2 height={15} width={15} />,
    "user-department-mapping-icon.svg" : <Icons.UserDepartmentMappingV2 height={15} width={15} />,
    
    // module icons
    "digiproc-icon.svg" : <Icons.DigiprocV2 height={19} width={19} />,
    "allokator-icon.svg" : <Icons.AllokatorV2 height={19} width={19} />,
    "digisales-icon.svg" : <Icons.DigisalesV2 height={19} width={19} />,

    "grievance-icon.svg" : <Icons.Grievance height={19} width={19} />,
    "service-order-icon.svg" : <Icons.ServiceOrderV2 height={19} width={19} />,
    "trf-request-icon.svg" : <Icons.TrfRequestIcon height={19} width={19} />
    
}


export const SideMenuFilledIcons = {
    "defaultIcon" :  <Icons.ProductsFilledV2 height={19} width={19} />,

    "dashboard-icon.svg" : <Icons.DashboardMenuFilledV2 height={19} width={19} />,
    "products-icon.svg" : <Icons.ProductsFilledV2 height={19} width={19} />,
    "sales-indent-icon.svg" : <Icons.SalesIndentFilledV2 height={19} width={19} />,
    "purchase-orders-icon.svg" : <Icons.PurchaseOrdersFilledV2 height={19} width={19} />,
    "shipments-icon.svg" : <Icons.ShipmentsFilledV2 height={19} width={19} />,
    "logistics-icon.svg" : <Icons.LogisticsFilledV2 height={19} width={19} />,
    "grc-icon.svg" : <Icons.GrcFilledV2 height={19} width={19} />,
    "ledger-icon.svg" : <Icons.LedgerFilledV2 height={19} width={19} />,
    "report-and-analytics-icon.svg" : <Icons.ReportsAndAnalyticsFilledV2 height={19} width={19}/>, 
    "administration-icon.svg" : <Icons.AdministrationFilledV2 height={19} width={19}/>, 
    "master-data-icon.svg" : <Icons.MasterDataFilledV2 height={19} width={19}/>, 

    "mappings-icon.svg" : <Icons.MappingsFilledV2 height={19} width={19} />,
    "assortment-icon.svg" : <Icons.AssortmentFilledV2 height={19} width={19} />,
    "run-replenishment-icon.svg" : <Icons.RunReplenishmentFilledV2 height={19} width={19} />,
    "planning-orders-icon.svg" : <Icons.PlanningOrdersFilledV2 height={19} width={19} />,
    "adhoc-requests-icon.svg" : <Icons.AdhocRequestsFilledV2 height={19} width={19} />,
    "history-icon.svg" : <Icons.HistoryFilledV2 height={19} width={19} />,
    
    "quality-check-icon.svg" : <Icons.QualityCheckFilledV2 height={19} width={19} />,
    "asn-icon.svg" : <Icons.AsnFilledV2 height={19} width={19} />,
    "finance-icon.svg" : <Icons.FinanceFilledV2 height={19} width={19} />,
    "manage-icon.svg" : <Icons.ManageFilledV2 height={19} width={19} />,

    "lr-processing-icon.svg" : <Icons.LrProcessingFilledV2 height={19} width={19} />,
    "grc-status-icon.svg" : <Icons.GrcStatusFilledV2 height={19} width={19} />,
    "sale-orders-icon.svg" : <Icons.SaleOrdersFilledV2 height={19} width={19} />,
    "delivery-challan-icon.svg" : <Icons.DeliveryChallanFilledV2 height={19} width={19} />,
    "pricelist-icon.svg" : <Icons.PricelistFilledV2 height={19} width={19} />,

    "agents-icon.svg" : <Icons.AgentsV2 height={17} width={17} />,
    "sets-icon.svg" : <Icons.SitesV2 height={19} width={19} />,
    "vendors-icon.svg" : <Icons.VendorsV2 height={16} width={16} />,
    "mailing-list-icon.svg" : <Icons.MailingListV2 height={17} width={17} />,
    "costsheet-library-icon.svg" : <Icons.CostSheetLibraryV2 height={17} width={17} />,
    "items-icon.svg" : <Icons.ItemsV2 height={17} width={17} />,
    "transports-icon.svg" : <Icons.TransportersV2 height={17} width={17} />,
    "fabric-library-icon.svg" : <Icons.FabricLibraryV2 height={17} width={17} />,
    "material-library-icon.svg" : <Icons.MaterialLibraryV2 height={17} width={17} />,
    "customers-icon.svg" : <Icons.CustomersV2 height={17} width={17} />,
    "sales-agents-icon.svg" : <Icons.SalesAgentsFilledV2 height={19} width={19} />,
    "sites-icon.svg" : <Icons.SitesV2 height={17} width={17} />,

    "manage-roles-icon.svg" : <Icons.ManageRolesV2 height={19} width={19} />,
    "create-roles-icon.svg" : <Icons.CreateRolesV2 height={19} width={19} />,
    "global-configuration-icon.svg" : <Icons.GlobalConfigurationV2 height={17} width={17} />,
    "user-data-mapping-icon.svg" : <Icons.UserDataMappingV2 height={17} width={17} />,
    "users-icon.svg" : <Icons.UsersV2 height={17} width={17} />,
    "data-sync-icon.svg" : <Icons.DataSyncV2 height={19} width={19} />,
    "audit-logs-icon.svg" : <Icons.AuditLogsV2 height={19} width={19} />,
    "api-logs-icon.svg" : <Icons.ApiLogsV2 height={17} width={17} />,
    "system-mails-icon.svg" : <Icons.SystemMailsV2 height={17} width={17} />,
    "roles-icon.svg" : <Icons.RolesV2 height={17} width={17} />,

    "replenishments-icon.svg" : <Icons.ReplenishmentV2 height={15} width={15} />,
    "inventory-controls-icon.svg" : <Icons.InventoryControlV2 height={15} width={15} />,
    "sales-icon.svg" : <Icons.SalesV2 height={15} width={15} />,
    "purchase-icon.svg" : <Icons.PurchaseFilledV2 height={17} width={17} />,
    "accounting-icon.svg" : <Icons.AccountingV2 height={15} width={15} />,
    "stock-icon.svg" : <Icons.StockV2 height={15} width={15} />,
    "report-and-analytics-logistics-icon.svg" : <Icons.ReportAnalyticsLogisticsV2 height={15} width={15} />,
    "report-and-analytics-shipment-icon.svg" : <Icons.ReportAnalyticsShipmentV2 height={15} width={15} />,
    
    "set-icon.svg" : <Icons.SetV2 height={15} width={15} />,
    "replenishment-summary-icon.svg" : <Icons.ReplenishmentSummaryFilledV2 height={15} width={15} />,
    "user-department-mapping-icon.svg" : <Icons.UserDepartmentMappingV2 height={15} width={15} />,

    "grievance-icon.svg" : <Icons.GrievanceFilled height={19} width={19} />,
    "forecastDashboard-icon.svg" : <Icons.SalesForecastFilledV2 height={19} width={19} />,
    "service-order-icon.svg" : <Icons.ServiceOrderFilledV2 height={19} width={19} />,
    "trf-request-icon.svg" : <Icons.TrfRequestFilled height={19} width={19} />

}


export default SideMenuIcons;